import { withSentryReactRouterV6Routing } from '@sentry/react';
import { Routes as LibRoutes } from 'react-router';

export const Routes = SSR_MODE ? LibRoutes : withSentryReactRouterV6Routing(LibRoutes);
